import { apiBaseURL } from '../config/apiConfig';

export async function downloadBlob(path: string, filename: string): Promise<void> {
  const token = localStorage.getItem('auth_token');

  const res = await fetch(`${apiBaseURL}${path}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/octet-stream',
    },
  });

  if (!res.ok) throw new Error(`Download failed: ${res.status}`);

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
